export const LinkData = [
  {
    id: 1,
    title: "Home",
    url: "/",
  },
  {
    id: 2,
    title: "About",
    url: "/about",
  },
  {
    id: 3,
    title: "courses",
    url: "/courses",
  },
  {
    id: 4,
    title: "Instructor",
    url: "/instructor",
  },
  {
    id: 5,
    title: "blog",
    url: "/blog",
  },
  {
    id: 6,
    title: "gallery",
    url: "/gallery",
  },
  {
    id: 7,
    title: "contact",
    url: "/contact",
  },
  {
    id: 8,
    title: "certificate",
    url: "/certificate",
  },
]

export const courses = [
  {
    id: 1,
    cover: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    title: "Computer Basics Course",
    lessons: 10,
    rating: "4.5 (100)",
    instructorImage: "/images/img1.jpg", // Kamaljit Kaur
    instructorName: "Kamaljit Kaur", // Kamaljit Kaur
    category1: "Computer Science",
    category2: "Basics",
    price: 2699,
  },
  {
    id: 2,
    cover: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    title: "120 Hours Computer Course",
    lessons: 12,
    rating: "4.8 (30)",
    instructorImage: "/images/img2.jpg", // Gurdarshan Kaur
    instructorName: "Gurdarshan Kaur", // Gurdarshan Kaur
    category1: "Computer Science",
    category2: "Advanced",
    price: 4000,
  },
  {
    id: 3,
    cover: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80",
    title: "Diploma in Computer Applications",
    lessons: 18,
    rating: "4.6 (99)",
    instructorImage: "/images/img3.jpg", // Er. Daljit Singh
    instructorName: "Er. Daljit Singh", // Er. Daljit Singh
    category1: "Computer Applications",
    category2: "Diploma",
    price: 10000,
  },
  {
    id: 4,
    cover: "https://images.unsplash.com/photo-1542744095-291d1f67b221?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    title: "Advanced Diploma in Computer Applications",
    lessons: 22,
    rating: "4.3 (54)",
    instructorImage: "/images/img1.jpg", // Kamaljit Kaur
    instructorName: "Kamaljit Kaur", // Kamaljit Kaur
    category1: "Computer Applications",
    category2: "Advanced Diploma",
    price: 12400,
  },
  {
    id: 5,
    cover: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
    title: "Advanced Diploma in Computer Financial Accounting",
    lessons: 20,
    rating: "5.0 (66)",
    instructorImage: "/images/img2.jpg", // Gurdarshan Kaur
    instructorName: "Gurdarshan Kaur", // Gurdarshan Kaur
    category1: "Computer Applications",
    category2: "Financial Accounting",
    price: 15600,
  },
  {
    id: 6,
    cover: "https://images.unsplash.com/photo-1573855618996-b620af5af078?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Tally with GST Course",
    lessons: 31,
    rating: "4.0 (80)",
    instructorImage: "/images/img3.jpg", // Er. Daljit Singh
    instructorName: "Er. Daljit Singh", // Er. Daljit Singh
    category1: "Finance",
    category2: "GST",
    price: 4000,
  },
  {
    id: 7,
    cover: "https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2070&auto=format&fit=crop&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Diploma in Computer Teacher Training Course",
    lessons: 20,
    rating: "4.9 (55)",
    instructorImage: "/images/img1.jpg", // Kamaljit Kaur
    instructorName: "Kamaljit Kaur", // Kamaljit Kaur
    category1: "Teacher Training",
    category2: "Diploma",
    price: 15600,
  },
  {
    id: 8,
    cover: "https://d502jbuhuh9wk.cloudfront.net/courses/66c8757aa61a61466e0299a4/66c8757aa61a61466e0299a4_scaled_cover.jpg?v=1",
    title: "Diploma in Office Management Applications",
    lessons: 16,
    rating: "4.6 (90)",
    instructorImage: "/images/img2.jpg", // Gurdarshan Kaur
    instructorName: "Gurdarshan Kaur", // Gurdarshan Kaur
    category1: "Office Management",
    category2: "Diploma",
    price: 8000,
  },
  {
    id: 9,
    cover: "https://images.unsplash.com/photo-1599658880436-c61792e70672?q=80&w=2070&auto=format&fit=crop&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    title: "Data Entry Course",
    lessons: 13,
    rating: "4.2 (150)",
    instructorImage: "/images/img3.jpg", // Er. Daljit Singh
    instructorName: "Er. Daljit Singh", // Er. Daljit Singh
    category1: "Data Entry",
    category2: "Basic",
    price: 8000,
  },
];



export const reviews = [
  {
    id: 1,
    image:"images/Picture1.jpg",
    name: 'Jasmeet Kaur (TELUSHSP001)',
    text: 'The Computer Basics Course helped me overcome my fear of technology. From MS Paint to Emails, everything was taught clearly with hands-on practice. The instructor was very supportive throughout the journey!',
  },
  {
    id: 2,
    image:"images/Picture2.jpg",
    name: 'Sufiya (TELUSHSP002)',
    text: 'This course made me comfortable with using a computer! I can now write documents, create simple spreadsheets, and even print without asking for help. Perfect for beginners like me.',
  },
  {
    id: 3,
    image:"images/Picture3.jpg",
    name: 'Bhaviya Sharma (TELUSHSP005)',
    text: 'Every topic was explained step-by-step with real examples. I really enjoyed learning MS Paint, MS Word, and basic Internet usage. Great for seniors and beginners! Highly recommend!',
  },
  {
    id: 4,
    image:"images/Picture4.jpg",
    name: 'Vikram (TELUSHSP019)',
    text: 'Very practical and to the point. We worked on real-world accounting problems, which really boosted my skills. The instructor was knowledgeable and always available for questions. I feel confident in my abilities now.',
  },
  {
    id: 5,
    image:"images/Picture5.jpg",
    name: 'Rabina (TELUSHSP021)',
    text: 'This course explained Tally and GST concepts very clearly. Now I can easily manage accounts and file GST returns without confusion.',
  },
];

export const blogs = [
  {
    id: 1,
    cover: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1351&q=80",
    title: "Celebrating Student Success: Our Top Achievers of 2023",
    author: "Er. Daljit Singh",
    authorImage: "images/img3.jpg",
    topic: "Student Achievements",
    content:
      "At Telus Institute, we take immense pride in the achievements of our students. This year, our students have excelled in academics, sports, and extracurricular activities. From winning national-level competitions to publishing research papers, our students have made us proud. One of our students, Rohan Mehta, secured the first position in the National Mathematics Olympiad. Another student, Priya Singh, represented India in the International Science Fair held in Singapore. These achievements are a testament to the hard work and dedication of our students and faculty. We believe in nurturing talent and providing our students with the best opportunities to succeed. Our goal is to create future leaders who will make a positive impact on society. We are committed to supporting our students in every step of their journey. With state-of-the-art facilities and a dedicated faculty, we ensure that our students have everything they need to excel. Join us in celebrating the success of our students and be a part of their inspiring journey.",
    rating: 4.5,
  },
  {
    id: 2,
    cover: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    title: "The Future of Education: Trends Shaping the World",
    author: "Kamaljit Kaur",
    authorImage: "/images/img1.jpg",
    topic: "World Education",
    content:
      "The world of education is evolving at an unprecedented pace. From online learning platforms to AI-driven classrooms, the future of education is being shaped by technology. At Telus Institute, we are at the forefront of these changes, embracing innovative teaching methods to provide our students with the best learning experience. One of the key trends is personalized learning, where students can learn at their own pace and focus on their individual strengths. Another trend is the integration of artificial intelligence in education, which helps in creating customized learning paths for students. Virtual reality is also making its way into classrooms, providing immersive learning experiences. We believe that these trends will revolutionize the way education is delivered and received. Our faculty is trained to adapt to these changes and provide our students with the skills they need to thrive in the future. We are committed to staying ahead of the curve and ensuring that our students are well-prepared for the challenges of tomorrow. Join us in shaping the future of education and be a part of this exciting journey.",
    rating: 5,
  },
  {
    id: 3,
    cover: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1489&q=80",
    title: "Our Journey: How Telus Institute Became a Leader in Education",
    author: "Gurdarshan Kaur",
    authorImage: "/images/img2.jpg",
    topic: "Institute History",
    content:
      "Telus Institute has come a long way since its inception. What started as a small institution with a handful of students has now become a leader in the field of education. Our journey has been marked by numerous milestones, including the establishment of state-of-the-art facilities, the introduction of innovative teaching methods, and the achievement of academic excellence. Over the years, we have expanded our reach and now have campuses in multiple cities. Our faculty comprises some of the most experienced and dedicated educators in the country. We have also forged partnerships with leading universities and organizations around the world to provide our students with global exposure. Our alumni have gone on to achieve great success in various fields, making us proud. We believe that our success is a result of our commitment to quality education and our focus on the holistic development of our students. As we look to the future, we are excited about the opportunities that lie ahead and are committed to continuing our journey of excellence.",
    rating: 4,
  },
  {
    id: 4,
    cover: "https://images.unsplash.com/photo-1522204523234-8729aa6e3d5f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    title: "Innovative Teaching Methods at Telus Institute",
    author: "Gurdarshan Kaur",
    authorImage: "/images/img2.jpg",
    topic: "Innovative Teaching",
    content:
      "Innovation is at the heart of our teaching methods at Telus Institute. We believe that traditional teaching methods are no longer sufficient to prepare students for the challenges of the modern world. That is why we have embraced innovative teaching methods that focus on experiential learning, critical thinking, and problem-solving. One of the key methods we use is project-based learning, where students work on real-world projects to gain practical experience. We also use flipped classrooms, where students learn the theory at home and apply it in the classroom through discussions and activities. Technology plays a crucial role in our teaching methods, with the use of smart boards, online resources, and virtual labs. Our faculty is trained to use these methods effectively and provide our students with a dynamic learning experience. We believe that these methods not only enhance learning but also make it more engaging and enjoyable for students. Our goal is to create a learning environment that fosters creativity, innovation, and a love for learning. Join us in our journey to redefine education and provide our students with the best learning experience.",
    rating: 4.7,
  },
  {
    id: 5,
    cover: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80",
    title: "Making a Global Impact: Our Alumni Around the World",
    author: "Er. Daljit Singh",
    authorImage: "images/img3.jpg",
    topic: "Global Impact",
    content:
      "Our alumni are making waves across the globe, and we couldn't be prouder. From leading multinational companies to groundbreaking research, Telus Institute graduates are making a significant impact in various fields. One of our alumni, Ravi Verma, is now the CEO of a leading tech company in Silicon Valley. Another alumnus, Anjali Mehta, is a renowned scientist working on cutting-edge research in renewable energy. These success stories are a testament to the quality of education and the opportunities provided by Telus Institute. We believe in nurturing talent and providing our students with the skills and knowledge they need to succeed in a globalized world. Our alumni network is strong and active, with members supporting each other and contributing to the growth of the institute. We are committed to creating future leaders who will make a positive impact on society. Our goal is to ensure that our students are well-prepared for the challenges of the global economy and are equipped to make a difference in the world. Join us in celebrating the success of our alumni and be a part of our global community.",
    rating: 4.2,
  },
  {
    id: 6,
    cover: "https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    title: "Our Vision for the Future: Goals and Aspirations",
    author: "Kamaljit Kaur",
    authorImage: "/images/img1.jpg",
    topic: "Future Goals",
    content:
      "We are committed to shaping the future of education and ensuring a brighter future for our students and the world. Our vision is to create a learning environment that fosters creativity, innovation, and a love for learning. We aim to provide our students with the skills and knowledge they need to succeed in a rapidly changing world. One of our key goals is to expand our reach and establish campuses in more cities. We also plan to introduce new programs and courses that are aligned with the needs of the modern world. Another goal is to strengthen our partnerships with leading universities and organizations around the world to provide our students with global exposure. We believe that education is the key to solving many of the world's problems, and we are committed to playing our part in creating a better future. Our faculty and staff are dedicated to achieving these goals and providing our students with the best possible education. Join us in our journey to shape the future of education and make a positive impact on the world.",
    rating: 4.8,
  },
];

export const instructors = [
  {
    id: 1,
    name: "Kamaljit Kaur",
    rating: 4.5,
    photo: "/images/img1.jpg",
    subject: "Instructor",
    experience: 10,
    hoursTaught: 100,
  },
  {
    id: 2,
    name: "Gurdarshan Kaur",
    rating: 5,
    photo: "/images/img2.jpg",
    subject: "Co-owner",
    experience: 8,
    hoursTaught: 400, 
  },
  {
    id: 3,
    name: "Er. Daljit Singh",
    rating: 5,  
    photo: "/images/img3.jpg",
    subject: "Technical Instructor",
    experience: 6,
    hoursTaught: 300,
  },  
];

export const coursedetail = [
  {
    id: 1,
    title: "Computer Basics Course",
    cover: "https://nebulas-it.com/wp-content/uploads/2017/03/1.png",
    category1: "Computer Basics",
    category2: "Beginner",
    lessons: 10,
    rating: 4.5,
    instructorName: "Instructor A",
    instructorImage: "https://randomuser.me/api/portraits/men/45.jpg",
    price: 2699,
    description: "Learn computer basics including MS Office, Internet, and Windows features.",
    longDescription: "Master the fundamentals of computers, covering MS Paint, WordPad, Microsoft Office Suite, Emailing, Printing, and basic Windows operations. Perfect for beginners starting their computer journey.",
    students: 1500,
    duration: 3,
    reviews: 250,
    learningOutcomes: [
      "MS Paint, WordPad, Notepad",
      "Microsoft Word, Excel, PowerPoint",
      "Emails & Internet Basics",
      "Windows Basic Features",
      "Printer Operations (Copy, Scan, Print)",
      "DOS Basics"
    ],
    curriculum: [
      {
        title: "Computer Basics",
        lessons: [
          { title: "Introduction to Computers", duration: 30 },
          { title: "MS Paint Basics", duration: 45 },
          { title: "WordPad and Notepad", duration: 45 },
          { title: "Microsoft Word Fundamentals", duration: 60 }
        ]
      },
      {
        title: "Office Applications",
        lessons: [
          { title: "Microsoft Excel Basics", duration: 60 },
          { title: "Microsoft PowerPoint Basics", duration: 60 },
          { title: "Emails and Internet", duration: 45 },
          { title: "Printer Handling", duration: 30 }
        ]
      }
    ]
  },
  {
    id: 2,
    title: "120 Hours Computer Course",
    cover: "https://images.unsplash.com/photo-1587620962725-abab7fe55159?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    category1: "Computer Basics",
    category2: "Short-Term",
    lessons: 12,
    rating: 4.6,
    instructorName: "Instructor B",
    instructorImage: "https://randomuser.me/api/portraits/women/46.jpg",
    price: 4000,
    description: "Comprehensive computer course covering Office applications, Typing, and Online Data Management.",
    longDescription: "Dive into Microsoft Office, Emails, Typing practice, and Online Data Management in this 120-hour complete computer course. Suitable for students looking for a professional introduction to computers.",
    students: 1100,
    duration: 120,
    reviews: 190,
    learningOutcomes: [
      "Microsoft Word, Excel, PowerPoint",
      "Emails, Internet, Data Management",
      "Typing English",
      "Windows OS Features",
      "Printer Handling",
      "DOS Basics"
    ],
    curriculum: [
      {
        title: "Office Applications",
        lessons: [
          { title: "Microsoft Word Basics", duration: 60 },
          { title: "Microsoft Excel Basics", duration: 60 },
          { title: "Microsoft PowerPoint Basics", duration: 60 },
          { title: "Emails and Internet", duration: 45 }
        ]
      },
      {
        title: "Typing and Management",
        lessons: [
          { title: "Typing Skills (English)", duration: 60 },
          { title: "Online Data Management", duration: 75 },
          { title: "Printer and Scanner Basics", duration: 45 },
          { title: "Windows Basic Features", duration: 45 }
        ]
      }
    ]
  },
  {
    id: 3,
    title: "DCA - Diploma in Computer Application",
    cover: "https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    category1: "Diploma",
    category2: "Computer Application",
    lessons: 18,
    rating: 4.7,
    instructorName: "Instructor C",
    instructorImage: "https://randomuser.me/api/portraits/men/47.jpg",
    price: 10000,
    description: "Get diploma certified in Computer Applications with this all-rounder program.",
    longDescription: "Learn a variety of computer skills like MS Office, HTML, DHTML, Tally ERP9 with GST, Online Data Management, Typing, and Computer Fundamentals. A perfect course for diploma certification seekers.",
    students: 2100,
    duration: 12,
    reviews: 330,
    learningOutcomes: [
      "Microsoft Office Suite",
      "TALLY ERP9 with GST",
      "HTML and DHTML Basics",
      "Computer Fundamentals",
      "Typing Skills",
      "Online Data Management"
    ],
    curriculum: [
      {
        title: "Computer Applications",
        lessons: [
          { title: "MS Word, Excel, PowerPoint", duration: 60 },
          { title: "HTML and DHTML Basics", duration: 75 },
          { title: "Tally ERP9 with GST", duration: 90 },
          { title: "Computer Fundamentals", duration: 60 }
        ]
      },
      {
        title: "Technical Skills",
        lessons: [
          { title: "Typing and Data Management", duration: 60 },
          { title: "Operating Systems Overview", duration: 75 },
          { title: "Input/Output Devices", duration: 45 },
          { title: "Online Data Handling", duration: 60 }
        ]
      }
    ]
  },
  {
    id: 4,
    title: "ADCA - Advanced Diploma in Computer Application",
    cover: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    category1: "Diploma",
    category2: "Advanced",
    lessons: 22,
    rating: 4.8,
    instructorName: "Instructor D",
    instructorImage: "https://randomuser.me/api/portraits/women/47.jpg",
    price: 12400,
    description: "Advanced computer diploma including programming, cyber security, and project work.",
    longDescription: "An all-in-one advanced diploma course covering Microsoft Office, Tally, HTML, DHTML, Cyber Security basics, Multimedia, C/Python/Java basics, Networking Concepts, and Project Work. Best for in-depth computer training.",
    students: 1800,
    duration: 12,
    reviews: 300,
    learningOutcomes: [
      "Office Suite Mastery",
      "Cyber Security Basics",
      "C/Python/Java Basics",
      "Networking Concepts",
      "Project-Based Learning",
      "Tally ERP with GST"
    ],
    curriculum: [
      {
        title: "Advanced Computer Applications",
        lessons: [
          { title: "MS Excel with Advanced Excel", duration: 75 },
          { title: "Tally ERP with GST", duration: 90 },
          { title: "Multimedia & Graphics", duration: 90 },
          { title: "Cyber Security Basics", duration: 60 }
        ]
      },
      {
        title: "Programming and Networking",
        lessons: [
          { title: "C/Python/Java Basics", duration: 90 },
          { title: "Networking Concepts", duration: 75 },
          { title: "Project Work", duration: 90 },
          { title: "Operating Systems and Fundamentals", duration: 60 }
        ]
      }
    ]
  },
  {
    id: 5,
    title: "ADCFA - Advanced Diploma in Computer Financial Accounting",
    cover: "https://nbi-assets.spicyweb.net.au/main/_1500xAUTO_crop_center-center_none/nbi-general.jpg",
    category1: "Diploma",
    category2: "Financial Accounting",
    lessons: 20,
    rating: 4.7,
    instructorName: "Instructor E",
    instructorImage: "https://randomuser.me/api/portraits/men/48.jpg",
    price: 15600,
    description: "Master accounting and financial computing with ADCFA including Tally with GST and Cyber Security Basics.",
    longDescription: "Gain comprehensive skills in accounting, advanced Tally with GST, online data management, cyber security, multimedia, and office applications with this one-year advanced diploma course.",
    students: 1200,
    duration: 12,
    reviews: 220,
    learningOutcomes: [
      "Fundamental of Computers",
      "Advanced Excel & Word (Bill Formats)",
      "Internet Applications & Online Form Fill-up",
      "Advanced Tally with GST",
      "Cyber Security Basics",
      "Multimedia & Graphics Tools"
    ],
    curriculum: [
      {
        title: "Financial Applications",
        lessons: [
          { title: "Advanced Tally with GST", duration: 90 },
          { title: "Golden Rules of Accounting", duration: 60 },
          { title: "VAT, TDS, CST, Service Tax", duration: 75 },
          { title: "E-Filing of Tax Returns", duration: 60 }
        ]
      },
      {
        title: "IT and Cyber Security",
        lessons: [
          { title: "Internet Applications & Email", duration: 45 },
          { title: "Cyber Security Basics", duration: 60 },
          { title: "Multimedia & Graphics Basics", duration: 75 },
          { title: "Computer Lab Practical", duration: 90 }
        ]
      }
    ]
  },
  {
    id: 6,
    title: "Tally With GST",
    cover: "https://images.unsplash.com/photo-1573855619003-97b4799dcd8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    category1: "Short-Term",
    category2: "Accounting",
    lessons: 30,
    rating: 4.5,
    instructorName: "Instructor F",
    instructorImage: "https://randomuser.me/api/portraits/women/48.jpg",
    price: 4000,
    description: "Learn complete Tally ERP9 with GST concepts, ledger entries, reports, and accounting groups.",
    longDescription: "This course covers all essential Tally ERP9 with GST topics including purchase/sales entries, debit-credit notes, ledgers, reports, GST setup, and complete practical accounting for businesses.",
    students: 800,
    duration: 6,
    reviews: 150,
    learningOutcomes: [
      "Tally ERP9 Installation and Setup",
      "Ledger and Group Creation",
      "GST Entry and Reporting",
      "Sales and Purchase Transactions",
      "Balance Sheet and Profit & Loss Statements",
      "Voucher Management"
    ],
    curriculum: [
      {
        title: "Tally Fundamentals",
        lessons: [
          { title: "Introduction to Tally and Accounting Basics", duration: 45 },
          { title: "GST Setup and Transactions", duration: 60 },
          { title: "Ledger and Group Creation", duration: 45 },
          { title: "Voucher Entries and Reporting", duration: 60 }
        ]
      },
      {
        title: "Advanced Tally Practices",
        lessons: [
          { title: "Inventory and Stock Management", duration: 60 },
          { title: "Final Reports & Balance Sheets", duration: 75 },
          { title: "Practical GST Accounting", duration: 90 },
          { title: "Course Completion Project", duration: 60 }
        ]
      }
    ]
  },
  {
    id: 7,
    title: "DCTT - Diploma in Computer Teacher Training",
    cover: "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    category1: "Diploma",
    category2: "Teaching",
    lessons: 20,
    rating: 4.8,
    instructorName: "Instructor G",
    instructorImage: "https://randomuser.me/api/portraits/men/49.jpg",
    price: 15600,
    description: "Become a certified computer instructor with DCTT, including MS Office, Tally, Cyber Security, and basic programming.",
    longDescription: "The DCTT program trains you in MS Office, Tally Prime with GST, teaching methodology, cyber security, basic programming (C, Python, Java), and using educational tech tools, preparing you for a career as a computer teacher.",
    students: 1000,
    duration: 12,
    reviews: 210,
    learningOutcomes: [
      "Computer Fundamentals and MS Office",
      "Tally Prime with GST",
      "Teaching Methods and Online Tools",
      "Basic Programming (C, Python, Java)",
      "Networking and Cyber Security",
      "Multimedia Tools for Teaching"
    ],
    curriculum: [
      {
        title: "Teaching Skills",
        lessons: [
          { title: "MS Word, Excel, PowerPoint, Access", duration: 60 },
          { title: "Teaching Methodology and Tools", duration: 60 },
          { title: "Cyber Security Basics", duration: 60 },
          { title: "Online Teaching Platforms", duration: 60 }
        ]
      },
      {
        title: "Technical Skills",
        lessons: [
          { title: "Programming Concepts (C, Python, Java)", duration: 90 },
          { title: "Tally Prime with GST", duration: 90 },
          { title: "Networking Concepts", duration: 75 },
          { title: "Final Teaching Project", duration: 60 }
        ]
      }
    ]
  },
  {
    id: 8,
    title: "DOMA - Diploma in Office Management Application",
    cover: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    category1: "Diploma",
    category2: "Office Management",
    lessons: 16,
    rating: 4.6,
    instructorName: "Instructor H",
    instructorImage: "https://randomuser.me/api/portraits/women/49.jpg",
    price: 8000,
    description: "Master office tools, RDBMS, financial accounting basics, and communication skills with DOMA.",
    longDescription: "The DOMA program offers training in MS Office, RDBMS with MS Access, financial accounting basics, Tally accounting, typing, and soft skills, preparing you for administrative and office management roles.",
    students: 950,
    duration: 6,
    reviews: 180,
    learningOutcomes: [
      "MS Office Suite Mastery",
      "RDBMS and MS Access",
      "Financial Accounting Basics",
      "Soft Skills and Interview Preparation",
      "Tally GST Basics",
      "Office Documentation Projects"
    ],
    curriculum: [
      {
        title: "Office Applications",
        lessons: [
          { title: "MS Office Suite (Word, Excel, PowerPoint, Access)", duration: 60 },
          { title: "Internet Applications and Email", duration: 45 },
          { title: "Computerized Accounting with Tally", duration: 75 },
          { title: "Life Projects on Office Package", duration: 90 }
        ]
      },
      {
        title: "Soft Skills",
        lessons: [
          { title: "Soft Skills and Personality Development", duration: 60 },
          { title: "Typing Skills and Practice", duration: 45 },
          { title: "Interview Preparation", duration: 60 },
          { title: "Final Office Management Project", duration: 90 }
        ]
      }
    ]
  },
  {
    id: 9,
    title: "Data Entry Course",
    cover: "https://images.unsplash.com/photo-1556742044-3c52d6e88c62?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
    category1: "Short-Term",
    category2: "Data Entry",
    lessons: 13,
    rating: 4.5,
    instructorName: "Instructor I",
    instructorImage: "https://randomuser.me/api/portraits/men/50.jpg",
    price: 8000,
    description: "Practical data entry course including MS Office, speed typing, and real-world assignments.",
    longDescription: "This course teaches data entry with MS Office, file conversion, scanning, real-life assignments, typing accuracy, and speed testing, ideal for entry-level job preparation in offices and organizations.",
    students: 700,
    duration: 6,
    reviews: 140,
    learningOutcomes: [
      "MS Office for Data Entry",
      "Speed Typing and Accuracy",
      "Data Cleaning and Formatting",
      "Real-Life Data Entry Projects",
      "File Conversion Techniques",
      "Typing Speed Test Certification"
    ],
    curriculum: [
      {
        title: "Data Entry Skills",
        lessons: [
          { title: "Typing Skills and Speed Training", duration: 45 },
          { title: "Numeric and Invoice Data Entry", duration: 60 },
          { title: "Scanning, Printing & Saving Files", duration: 45 },
          { title: "Real Life Assignments and Speed Test", duration: 60 }
        ]
      },
      {
        title: "Office Tools",
        lessons: [
          { title: "MS Word, Excel, PowerPoint Basics", duration: 60 },
          { title: "Internet Applications and Online Form Fill", duration: 45 },
          { title: "File Conversion and Data Cleaning", duration: 60 },
          { title: "Final Certification Test", duration: 45 }
        ]
      }
    ]
  }
];
